<template>
  <div class="detail">
    <h2 class="detail-title">商品清单</h2>
    <div v-if="!isDetail" class="handle-btn">
      <eui-btn type="secondary" @click="handleAddProduct">添加商品行</eui-btn>
      <eui-btn type="secondary" @click="openBatchImport">批量导入商品</eui-btn>
    </div>

    <!-- table -->
    <el-form ref="productForm" :rules="formDataRules" :model="tableFormData" class="form-content" size="small">
      <div class="table-content">
        <TableList
          index-show
          :table-label="tableLabel"
          :table-data="tableFormData.skuList"
          :header-cell-class-name="must"
        >
          <template v-for="(item, index) in slots" #[item.slot]="{ scope: { row, $index } }">
            <template v-if="isDetail">
              <span v-if="item.slot === 'price'" :key="index" class="row-price">
                {{ formattedPrice(row[item.param]) }}
              </span>
              <span v-else :key="index">{{ row[item.param] }}</span>
            </template>
            <template v-else>
              <el-form-item
                :key="index"
                :prop="'skuList.' + $index + `.${item.param}`"
                :rules="formDataRules[item.param]"
              >
                <el-tooltip
                  :content="row[item.param]"
                  placement="top-start"
                  :disabled="row[item.param] && row[item.param].length <= 12"
                >
                  <el-input
                    v-model.trim="row[item.param]"
                    :maxlength="item.maxLength"
                    show-word-limit
                    class="edit-input"
                    size="small"
                    :placeholder="item.label"
                  ></el-input>
                </el-tooltip>
              </el-form-item>
            </template>
          </template>
          <template #needPay="{ scope: { row, $index } }">
            <span class="row-price">{{ formattedPrice(needPay(row, $index)) }}</span>
          </template>
          <template #handle="{ scope: { row, $index } }">
            <eui-btn
              v-if="tableFormData.skuList.length > 1 && !isDetail"
              type="link"
              font-size="12px"
              @click="handleDelete($index, row)"
            >
              删除
            </eui-btn>
          </template>
        </TableList>
      </div>
    </el-form>
    <!-- 批量导入 -->
    <BatchImport :batch-import-visible.sync="batchImportVisible" @getBatchImportList="getBatchImportList" />
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import Decimal from 'decimal.js';
import _ from 'lodash';
import BatchImport from './BatchImport.vue';
import {
  productTableLabel as tableLabel,
  validatePrice,
  validateQuantity,
  formattedPrice,
} from '../../common/stockOrder';

export default {
  components: { TableList, BatchImport },
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({
        skuList: [],
      }),
    },
  },
  data() {
    return {
      batchImportVisible: false,
      tableFormData: {
        skuList: [
          {
            product: '',
            quantity: '',
            price: '',
            unit: '',
            specs: '',
            brand: '',
            description: '',
            mySkuId: new Date().getTime(),
            category: '',
            needPay: '',
          },
        ],
      },
      formDataRules: {
        product: {
          type: 'string',
          required: true,
          message: '请输入商品名称',
          trigger: ['blur', 'change'],
        },
        specs: {
          required: true,
          message: '请输入规格型号',
          trigger: ['blur', 'change'],
        },
        price: [
          {
            required: false,
            message: '请输入价格',
            trigger: ['blur', 'change'],
          },
          { validator: validatePrice },
        ],
        quantity: [
          {
            required: true,
            message: '请输入数量',
            trigger: ['blur', 'change'],
          },
          {
            validator: validateQuantity,
          },
        ],
        unit: {
          type: 'string',
          required: true,
          message: '请输入计量单位',
          trigger: ['blur', 'change'],
        },
      },
      tableLabel: _.cloneDeep(tableLabel),
    };
  },
  computed: {
    columnTotalPrice() {
      const { skuList } = this.tableFormData;
      console.log(111);
      const totalPrice = skuList.reduce((total, item) => {
        const { needPay } = item;
        const needPayNum = new Decimal(Number(needPay || 0));
        const totalNum = new Decimal(Number(total || 0));
        return totalNum.plus(needPayNum);
      }, 0);
      console.log('totalPrice:', totalPrice.toString());
      return totalPrice.toString();
    },
    slots() {
      return this.tableLabel.filter((item) => item.slot && item.slot !== 'needPay' && item.slot !== 'handle');
    },
  },
  watch: {
    isDetail: {
      handler(newVal) {
        if (newVal) {
          this.tableLabel.pop();
        }
      },
      immediate: true,
    },
    formData: {
      handler(newVal) {
        const list = newVal.skuList.map((item) => {
          return {
            ...item,
            needPay: '',
            price: String(item.price),
            quantity: String(item.quantity),
          };
        });
        this.tableFormData.skuList = list;
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    formattedPrice,
    needPay(row, index) {
      const { price, quantity } = row;
      const priceNum = new Decimal(Number(price) || 0);
      const quantityNum = new Decimal(Number(quantity) || 0);
      const needPayNum = quantityNum.times(priceNum);
      // this.$set(this.tableFormData.skuList[index], 'needPay', needPayNum);
      this.tableFormData.skuList[index].needPay = needPayNum;
      const needPayTow = needPayNum.toString();
      return needPayTow;
    },
    handleAddProduct() {
      const newVal = {
        product: '',
        quantity: '',
        price: '',
        unit: '',
        specs: '',
        brand: '',
        description: '',
        mySkuId: new Date().getTime(),
        category: '',
        needPay: '',
      };
      this.tableFormData.skuList.push(newVal);
    },
    getBatchImportList(val) {
      const list = val.map((item) => {
        return {
          ...item,
          needPay: '',
          price: String(item.price),
          quantity: String(item.quantity),
        };
      });
      this.tableFormData.skuList = [...list, ...this.tableFormData.skuList];
      console.log(this.tableFormData.skuList, 'this.tableFormData.skuList');
    },
    // 删除-商品
    handleDelete(index) {
      this.tableFormData.skuList.splice(index, 1);
    },
    must({ columnIndex }) {
      if (this.isDetail) return '';
      const mustData = [1, 2, 4, 5];
      if (mustData.includes(columnIndex)) {
        return 'must';
      }
      return '';
    },
    openBatchImport() {
      this.batchImportVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table th.must div:before {
  content: '*';
  color: #ff1818;
}
.detail {
  padding: 20px;
  background: #fff;
  .detail-title {
    margin-bottom: 20px;
    font-size: 16px;
    color: #333;
  }
  .handle-btn {
    margin-bottom: 10px;
  }
}

::v-deep .row-price {
  color: red;
  font-size: 14px;
}
</style>
